<template>
	<div class="user-fragment">
		<div class="header">User</div>
		<div class="body">
			<div>
				<div class="label">Username</div>
				<string-view v-model="model.username" />
			</div>
			<div>
				<div class="label">Password</div>
				<string-view type="password" v-model="model.password" />
			</div>
		</div>
		<div class="footer">
			<button-view v-if="!id" @click="create">Create</button-view>
			<button-view v-if="id" @click="update">Update</button-view>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				model: {
					username: '',
					password: ''
				}
			};
		},
		props: {
			id: {
				type: Number,
				default: null
			}
		},
		methods: {
			create() {
				var self = this;

				this.axios.post('/portal/users/', this.model).then(function (r) {
					self.$emit('created', r.data);
					self.$store.commit('popModal');
				});
			},
			update() {
				var self = this;

				this.axios.put('/portal/users/' + this.id + '/', this.model).then(function (r) {
					self.$emit('updated', r.data);
					self.$store.commit('popModal');
				});
			}
		},
		mounted() {
			var self = this;

			if (this.id) {
				this.axios.get('/portal/users/' + this.id + '/').then(function (r) {
					console.log(r);

					self.model = {...self.model, ...r.data};

					console.log(self.model);
				});
			}
		}
	}
</script>S

<style lang="scss" scoped>
	.user-fragment {
		& > .header {
			font-size: 22px;
			padding: 20px;
		}

		& > .body {
			display: grid;
			grid-row-gap: 10px;
			padding: 0 20px 0 20px;

			> div > .label {
				margin-bottom: 5px;
			}
		}

		&  > .footer {
			padding: 20px;
			text-align: right;
		}
	}
</style>